export default "//file.bilionpass.com/japandx-portal/0.1.17/static/img/about-service-2.d9afe577-0e89ad.png";